module.exports = __webpack_public_path__ + "img/bottom-blue.314e9b3b.svg";